// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.category-color-picker .dropdown-toggle::before {\n  content: \"色\";\n}\n@media (min-width: 768px) {\n.category-color-picker .dropdown-toggle::before {\n    content: \"色変更\";\n}\n}\n", ""]);
// Exports
module.exports = exports;
